import React, { useContext } from 'react';
import { Button } from 'react-bootstrap';
import { HiOutlineBars3 } from 'react-icons/hi2';
import { AiOutlineLogout } from 'react-icons/ai';

import { NewContext } from '../../../Context/NewContext';

import './mobileheader.css';

export const MobileHeader = () => {
    const { setToggleSidebar, setConfirmationModalShow, setDeleteTag } = useContext(NewContext);

    return (
        <div className={`header bg-secondary text-white p-3 d-flex d-xl-none justify-content-between align-items-center`}>
            <div className='d-flex align-items-center'>
                <Button className={`sidebar-toggle-btn d-block d-xl-none me-3 px-2`} onClick={() => setToggleSidebar(true)}><HiOutlineBars3 size={"25px"} /></Button>
            </div>
            <Button variant='danger' className='px-2' onClick={() => { setDeleteTag("logout"); setConfirmationModalShow(true); }}><span className='me-2 d-none d-xl-inline'>Logout</span><AiOutlineLogout size={"25px"} /></Button>
        </div>
    )
}

export default MobileHeader